/*
 * Copyright (C) 2021 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

export interface DTableDataTreeNode<PARENT, CHILD> {}
